module.exports = __webpack_public_path__ + "static/meta-image-22b84ea104a28b7cad41bc7195ea9d47.jpg";